module.exports = __webpack_public_path__ + "img/NULS.851bcca4.svg";